import * as React from "react";
import { withLocalization, LocalizedComponentProps, LocalizedComponentClass } from "bernie-l10n";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

interface ReviewCardLinkProps extends LocalizedComponentProps {
  hotelName: string;
  index: number;
  hotelInfositeUrl: string;
}

const ReviewCardLink = (props: ReviewCardLinkProps) => (
  <TrackedLink
    title={props.l10n.formatText("hotelRecentReviews.linkTitle", props.hotelName)}
    className="uitk-card-link"
    moduleName="hotel-recent-reviews"
    rfrr={`card-${props.index}`}
    href={`${props.hotelInfositeUrl}#review-summary`}
  >
    {props.hotelName}
  </TrackedLink>
);

export const LocalizedReviewCardLink: LocalizedComponentClass<
  ReviewCardLinkProps
> = withLocalization(ReviewCardLink);
